<template>
  <v-container>
    <v-layout>
      <v-flex v-if="user.id === null" class="pa-3">
        <v-container>
          <v-layout row wrap align-center>
            <v-flex>
              <h1>Customer Profile</h1>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink>
              <CountdownTimer />
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex class="pb-3">
              <v-btn class="accent large" @click="continueAsGuest">
                Continue as Guest
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
        <v-layout row wrap class="login" align-center>
          <v-flex xs12 sm6>
            <v-card flat class="pa-4">
              <v-layout column justify-space-between>
                <v-spacer></v-spacer>
                <v-flex class="pb-3">
                  <h2 class="primary--text">Login to Your Profile</h2>
                </v-flex>
                <v-spacer></v-spacer>
                <LoginForm />
                <v-spacer></v-spacer>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6>
            <v-card flat class="create_account">
              <v-layout column justify-space-between>
                <v-spacer></v-spacer>
                <v-flex>
                  <h2 class="primary--text">Create a Profile</h2>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex class="ma-4">
                  <ul class="my-3 primary--text">
                    <li>Prefill contact information</li>
                    <li>Save this booking to your account</li>
                    <li>Update your booking online</li>
                  </ul>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex>
                  <v-btn @click="goToPath('/booking/user/new')" class="primary mt-3">
                    Create Profile
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex v-else class="pa-3">
        <v-container>
          <v-layout row wrap align-center>
            <v-flex>
              <h1 class="pb-3" primary--text>Customer Profile</h1>
              <p>You are logged in as <strong>{{ user.name_first }} {{ user.name_last }}</strong>.</p>
              <a @click="logout()" class="accent">Logout</a>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink>
              <CountdownTimer />
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Shared from "@/mixins/Shared";
import LoginForm from "@/components/forms/Login.vue";
import CountdownTimer from "@/components/CountdownTimer.vue";

export default {
  name: "LoginUser",
  mixins: [Shared],
  components: {LoginForm, CountdownTimer},
  mounted() {
    this.testCompleteStep(
      this.getFormIndexByPath(this.$route.path)
    );
  }
}
</script>
